export enum ConfirmationResultType {
  ACCEPT,
  REJECT,
}
